module.exports = __webpack_public_path__ + "img/12m.f0258c22.jpg";